// @ts-nocheck
export const MODEL_NAME = 'dynamic-list';
